<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="980"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--打印付款清单-->
          <el-button no="PrintPayment" type="primary" @click="printClickHandler">{{ $t('CargoMsg.Cargo_PrintPaymentList') }}</el-button>
          <!--电放资料   -->
          <el-button no="TelexReleaseMaterial" type="primary" @click="btnSurrenderedClickHandler">{{ $t('CargoMsg.Cargo_TelexReleaseMaterial') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="height: 40%">
        <cargo-ag-grid
          config-module="980002"
          :grid-options="audit.gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="audit.rowData"
          :grid-params.sync="audit.gridParams"
          style="width: 100%; min-height: 200px"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :total="total"
          :page-count="pageCount"
          config-module="980001"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
      <div class="section grid-wrapper" style="height: 30%">
        <cargo-ag-grid
          :grid-options="selectShow.gridOptions"
          :column-defs="columnDef"
          :row-data="selectShow.rowData"
          :grid-params.sync="selectShow.gridParams"
          style="width: 100%;height: 100%"
          @gridReady="onSelectShowGridReady"
        />
      </div>
    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />

    <show-surrendered-window
      :visible.sync="surrendered.visible"
      :single-release-entity="surrendered.entity"
    />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import {
  getContainerNoFunc,
  loadChargesFunc,
  querySingleReleaseVerifyPageableFunc,
  updateChargeAndDocFunc
} from '@/api/seaExport/cargoDoc'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { HBL } from '@/class/cargo/model/parameters/CargoDocConsts'
import ColumnUtils from '@/utils/ColumnUtils'
import WithholdReasonWindow from '@/views/cargo/v0/Clearing/components/releaseControl/withholdReasonWindow'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import showSurrenderedWindow from '@/views/cargo/v0/Clearing/components/releaseControl/showSurrenderedWindow'
import { APPLICATIONED, ONSINGLERELEASE } from '@/class/cargo/model/parameters/ReleaseState'
import { DocumentManage } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import DateUtils from '@/utils/dateUtils'
import { formatNumberToThousands } from '@/utils'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'HblSingleReleaseVerifyBaseView',
  components: {
    showSurrenderedWindow,
    WithholdReasonWindow,
    searchItem,
    cargoTemplateSelectorDialog
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      documentManage: new DocumentManage(),
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageCount: 0,
      audit: {
        selectedData: null,
        selectedFiles: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onGridCellFocused(event)
          },
          // 行点击事件
          onRowClicked: this.onRowClicked,
          // 行勾选事件
          onRowSelected: this.onRowSelected,
          defaultColDef: {
            resizable: true
          }
        },
        rowData: [],
        gridApi: null
      },
      selectShow: {
        selectedData: null,
        gridParams: {},
        gridOptions: {
          getRowStyle: (params) => {
            const row = params.data
            if (row.receivable) {
              return { 'color': '#078707' }
            } else {
              return { 'color': '#E00A29FF' }
            }
          }
        },
        rowData: [],
        nowJob: null,
        gridApi: null
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CargoDocList',
        data: {}
      },
      withOldWindow: {
        visible: false,
        list: []
      },
      surrendered: {
        visible: false,
        entity: {}
      },
      sopJobs: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.showBusinessInfo
            }
          }
        },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerChineseName', width: 100, colId: 'customerChineseName' },
        { headerName: this.$t('CargoMsg.Cargo_ConsignorSCode'), field: 'customerCnShortName', width: 100, colId: 'customerCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_AbbreviationOfConsignor'), field: 'customerShortName', width: 100, colId: 'customerShortName' },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'creditPeriod', width: 100, colId: 'creditPeriod',
          cellRenderer: (params) => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditUsed'), field: 'creditUsed', width: 100, colId: 'creditUsed',
          cellRenderer: (params) => {
            return ColumnUtils.creditUsedCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.creditUsedCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgent'), field: 'bookingAgentChineseName', width: 100, colId: 'bookingAgentChineseName' },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgentCode'), field: 'bookingAgentCnShortName', width: 100, colId: 'bookingAgentCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgentAbbreviation'), field: 'bookingAgentShortName', width: 100, colId: 'bookingAgentShortName' },
        { headerName: this.$t('CargoMsg.Cargo_CarrierShip'), field: 'carrierChineseName', width: 100, colId: 'carrierChineseName' },
        { headerName: 'SO NO.', field: 'soNoStr', width: 100, colId: 'soNoStr',
          tooltipValueGetter: (params) => params.value
        },
        { headerName: this.$t('CargoMsg.Cargo_ShippingCompanySCode'), field: 'carrierCnShortName', width: 100, colId: 'carrierCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_ShippingCompanySAbbreviation'), field: 'carrierShortName', width: 100, colId: 'carrierShortName' },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'dischargingPortCode', width: 100, colId: 'dischargingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETD'), field: 'etd', width: 100, colId: 'etd',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'eta', width: 100, colId: 'eta',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ATD'), field: 'atd', width: 100, colId: 'atd',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ATA'), field: 'ata', width: 100, colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VesselAndVoyage'),
          field: 'voyageFlightStr',
          width: 100,
          colId: 'voyageFlightStr'
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessStatus'), field: 'jobState', width: 100, colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          }
        },
        { headerName: 'MB/L', field: 'mblNo', width: 100, colId: 'mblNo' },
        { headerName: 'HBL', field: 'hblNo', width: 100, colId: 'hblNo' },
        { headerName: this.$t('CargoMsg.Cargo_HBLMode'), field: 'releaseType', width: 100, colId: 'releaseType',
          cellRenderer: (params) => {
            return ColumnUtils.getHBLBillReleaseTypeByCode(BlModeType.MBL.code, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TelexReleaseNo'), field: 'surrenderedNo', width: 100, colId: 'surrenderedNo' },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'sales', width: 100, colId: 'sales',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesDepartment'), field: 'salesDepartment', width: 100, colId: 'salesDepartment',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'), field: 'salesOffice', width: 100, colId: 'salesOffice',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckingURLStatus'), field: 'cfmState', width: 100, colId: 'cfmState',
          cellRenderer: (params) => {
            const data = CargoDocCfmState.getCargoDocCfmStateByCode(params.value)
            return this.$store.getters.language === 'zh' ? data.chineseName : data.englishName
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DataSent'),
          field: 'releaseReview',
          colId: 'releaseReview',
          initialWidth: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'el-checkbox',
            attrs: {
              isEditCBFunc: (params) => {
                return true
              }, trueLabel: 1, falseLabel: 0
            },
            valueChanged: p => {
              this.changeReleaseReviewHandler(p)
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Completed'), field: 'payable', colId: 'payable', initialWidth: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'el-checkbox',
            attrs: {
              isEditCBFunc: (params) => {
                return true
              }, trueLabel: true, falseLabel: false
            },
            valueChanged: p => {
              this.changePayableHandler(p)
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_InformationSentTime'), field: 'reviewDate', width: 100, colId: 'reviewDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CompletionTime'), field: 'agreePayDate', width: 100, colId: 'agreePayDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_2NdReleaseTime'), field: 'secondReleaseDate', width: 100, colId: 'secondReleaseDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MBLAudit'), field: 'mblReleaseReview', width: 100, colId: 'mblReleaseReview',
          cellRenderer: params => {
            return Number(params.value) === 1 ? '√' : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MBLPayable'), field: 'mblPayable', width: 100, colId: 'mblPayable',
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MBLCargoDetention'), field: 'mblWithhold', width: 100, colId: 'mblWithhold',
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MBLReviewTime'), field: 'mblReviewDate', width: 100, colId: 'mblReviewDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MBLPaymentTime'), field: 'mblAgreePayDate', width: 100, colId: 'mblAgreePayDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MBLTimeOfCargoHolding'), field: 'mblWithholdDate', width: 100, colId: 'mblWithholdDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks', width: 100, colId: 'remarks' },
        { headerName: this.$t('CargoMsg.Cargo_ReleasePerson'), field: 'releaseBy', width: 100, colId: 'releaseBy',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Auditor'), field: 'releaseReviewUser', width: 100, colId: 'releaseReviewUser',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessReferenceNo'),
          field: 'customerRefNo',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.NCReferenceNo'),
          field: 'agentRefNo',
          colId: 'agentRefNo',
          hide: true,
          width: 150
        }
      ]
    },
    columnDef() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SettlingCompanySCode'), field: 'accountId', width: 180, colId: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'cnShortName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlingCompanySAbbreviation'), field: 'accountId', width: 180, colId: 'accountId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', width: 100, colId: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'), field: 'receivable', width: 100, colId: 'receivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 100, colId: 'currency' },
        { headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'amount', width: 100, colId: 'amount',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DomesticOrInternational'), field: 'oversea', width: 100, colId: 'oversea',
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TheAmountOfWrittenOff'), field: 'verifiedAmount', width: 100, colId: 'verifiedAmount',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AmountNotWrittenOff'), field: 'verifiedAmountStr', width: 100, colId: 'verifiedAmountStr'
        },
        { headerName: this.$t('CargoMsg.Cargo_Payable'), field: 'payable', width: 100, colId: 'payable',
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RelatedBLNo'), field: 'relatedMbl', width: 100, colId: 'relatedMbl' },
        { headerName: this.$t('CargoMsg.Cargo_TypeOfBill'), field: 'actualType', width: 100, colId: 'actualType' },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffNo'), field: 'actualAmountNo', width: 100, colId: 'actualAmountNo' },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', width: 100, colId: 'invoiceNo' }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.initCustomSearchItems()
  },
  beforeMount() {
    this.documentManage.set('showBusinessInfo', () => {
      this.showBusinessInfo()
    })
  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.audit.gridApi = p.api
    },
    onSelectShowGridReady(p) {
      this.selectShow.gridApi = p.api
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.jobNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.jobNo = ''
      }
      this.doAdvancedQuery(data)
    },
    // 高级查询
    doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', [0, 1, 2, 11, 13], AdvancedSearchConsts.OPERATOR_IN.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      const conditionMap = {}
      let expectDateOption = {}
      // 是否已核销
      if (AdvancedSearchOption.hasField('charge.PAID_OFF', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('charge.PAID_OFF', this.filterJson.conditions)
        conditionMap['paidOff'] = expectDateOption.value
        AdvancedSearchOption.removeOption('charge.PAID_OFF', this.filterJson.conditions)
      }
      conditionMap['docType'] = HBL
      this.filterJson.page = 3
      this.filterJson.conditions.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', 0, OperatorConstants.OPERATOR_EQUAL.code))
      this.filterJson.condition = conditionMap
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      querySingleReleaseVerifyPageableFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    setVoyageFlight(data) {
      if (data.vessel && data.voyageFlight) {
        return data.vessel + '/' + data.voyageFlight
      } else if (data.vessel) {
        return data.vessel
      } else if (data.voyageFlight) {
        return data.voyageFlight
      } else {
        return ''
      }
    },
    setSoNo(data) {
      let v = data.soNo
      if (data.soNo && data.soNo.indexOf('\n') !== -1) {
        const n = data.soNo.split('\n')
        v = n[0] + '...'
      }
      return v
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.audit.gridOptions.api, 'uuid')
      if (res.data.list) {
        for (const data of res.data.list) {
          CargoDocUtil.setFieldHandler(data)
        }
      }
      this.audit.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.audit.selectedData = null
      this.selectShow.rowData = []
      this.selectShow.nowJob = null
      this.audit.gridApi.clearFocusedCell()
      this.loading.close()
      selectedStatus.revert()
    },
    onRowClicked(event) {
      this.doRowClicked(event, true)
    },
    doRowClicked(event, isOn) {
      if (!event || !event.data) return
      this.audit.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.audit.selectedData = node
        // 根据业务查询对应费用数据
        if (this.selectShow.nowJob !== this.audit.selectedData.jobUuid && isOn) {
          this.queryChargeListHandler(this.audit.selectedData.jobUuid)
        }
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.audit.selectedFiles.push(event.data)
      } else {
        this.audit.selectedFiles = this.audit.gridApi.getSelectedRows()
      }
      this.doRowClicked(event, false)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.audit.selectedData = {}
      if (this.audit.gridApi) {
        this.audit.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.audit.selectedData = f
            }
          }
        })
      }
    },
    // 加载费用
    queryChargeListHandler(jobUuid) {
      this.selectShow.rowData = []
      loadChargesFunc({ jobUuid }).then(res => {
        for (const data of res.data) {
          data.verifiedAmountStr = ColumnUtils.formatNumber((data.amount - data.verifiedAmount), 2)
        }
        this.selectShow.rowData = res.data
        this.selectShow.nowJob = jobUuid
      })
    },
    // 打印付款清单
    printClickHandler() {
      const rows = this.audit.gridApi.getSelectedRows()
      const list = []
      for (const c of rows) {
        if (c.payable) {
          list.push(c.uuid)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('Message.ThereAreNoPayableBillsToPrint'))
        return
      }
      const params = {}
      params.DOC_UUID = Array.from(list, p => p.uuid)
      this.templateSelectorDialog.category = 'CargoDocList'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 电放资料
    btnSurrenderedClickHandler() {
      if (!this.audit.selectedData || !this.audit.selectedData.uuid) {
        this.$message.warning(this.$t('Message.NoSplittingRecordSelected'))
        return
      }
      const jobUuid = this.audit.selectedData.jobUuid
      getContainerNoFunc({ jobUuid }).then(res => {
        const c = res.data
        this.surrendered.visible = true
        this.surrendered.entity = this.audit.selectedData
        this.surrendered.entity.containerNo = c
      })
    },
    // 已发资料
    changeReleaseReviewHandler(event) {
      if (event && event.data) {
        const d = event.data
        if (!d.releaseReview) {
          if (d.releaseState === APPLICATIONED.code) {
            let name = ''
            if (d.surrenderedApplicant) {
              name = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', d.surrenderedApplicant, 'chineseName')
            }
            this.$message.warning(this.$t('Clearing.TelexContact0ToApplication', [name]))
            return
          } else if (d.releaseState === ONSINGLERELEASE.code) {
            this.$message.warning(this.$t('Clearing.ReleasePleasePrepareForWithholding'))
            return
          }
        }
        const date = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        // 放单状态
        d.reviewDate = d.releaseReview ? date : null
        if (d.reviewDate == null) {
          d.payable = false
          d.agreePayDate = null
        }
        d.releaseState = d.releaseReview ? 1 : 0
        d.releaseDate = d.releaseReview ? date : null
        const docList = []
        docList.push(d)
        updateChargeAndDocFunc(docList, { num: 1 }).then(res => {
          this.refreshList(d)
          this.queryChargeListHandler(this.audit.selectedData.jobUuid)
          this.$message.success('状态更新成功.')
        })
      }
    },
    // 完成
    changePayableHandler(event) {
      if (event && event.data) {
        const d = event.data
        if (!d.payable) {
          if (d.releaseState === APPLICATIONED.code) {
            let name = ''
            if (d.surrenderedApplicant) {
              name = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', d.surrenderedApplicant, 'chineseName')
            }
            this.$message.warning(this.$t('Clearing.TelexContact0ToApplication', [name]))
            return
          } else if (d.releaseState === ONSINGLERELEASE.code) {
            this.$message.warning(this.$t('Clearing.ReleasePleasePrepareForWithholding'))
            return
          }
        }
        this.changePayableLoadCharge(d)
      }
    },
    changePayableLoadCharge(d) {
      if (d) {
        const date = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        if (d.releaseReview === 0 && d.payable) {
          // 审核状态
          d.releaseReview = 1
          d.reviewDate = date
          // 放单状态
          d.releaseState = 1
          d.releaseDate = date
        }
        // 可付款状态
        d.agreePayDate = d.payable ? date : null
        const docList = []
        docList.push(d)
        updateChargeAndDocFunc(docList, { num: 4 }).then(res => {
          this.refreshList(d)
          this.queryChargeListHandler(this.audit.selectedData.jobUuid)
          this.$message.success('状态更新成功.')
        })
      }
    },
    showBusinessInfo(e) {
      if (!this.audit.selectedData) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.audit.selectedData)
      this.templateSelectorDialog.category = 'JOB_DETAIL'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.audit.selectedData.jobUuid }
      this.templateSelectorDialog.visible = true
    },
    refreshList(d) {
      const index = this.audit.rowData.findIndex(row => { return row.uuid === d.uuid })
      const rowData = this.audit.rowData
      rowData[index] = d
      this.audit.rowData = [...rowData]
    },
    initCustomSearchItems() {
      this.customSearchItems = ColumnUtils.getBlModeList(BlModeType.HBL.code)
      this.searchItemAutoInit = true
      return this.customSearchItems
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
